import React, { memo } from 'react';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import DynamicTextField from './DynamicTextField';
import DynamicAutoComplete from './DynamicAutoComplete';
import Typography from '@material-ui/core/Typography';
import DynamicDateField from './DynamicDateField';
import DynamicRadioControl from './DynamicRadioControl';
import DynamicFileControl from './DynamicFileControl';
import DynamicCheckboxControl from './DynamicCheckboxControl';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import SaveIcon from '@material-ui/icons/Save';
import ErrorIcon from '@material-ui/icons/Error';
import Box from '@material-ui/core/Box';
import DynamicDatePickControl from './DynamicDatePickControl';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as Constants from '../shared/constants';
import MuiAlert from '@material-ui/lab/Alert';
import IdentificationDocument from './IdentificationDocumentsSection/IdentificationDocument';
import BasicCollapsible from './BasicCollapsible';
import EntityTypeCodes from '../shared/EntityTypeCodes';
import CreateIdentificationDocument from './IdentificationDocumentsSection/CreateIdentificationDocument';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as selfServiceActions } from "../redux/actions/selfServiceActions";
import * as settings from "../shared/settingsConstants";
import { withTheme } from '@material-ui/core/styles';
import * as authHelpers from '../authentication/authHelpers';
import * as routeHelpers from "../authentication/routeHelpers";
import { useRouteMatch } from 'react-router-dom';
import { Add } from '@material-ui/icons';

class EntityFields extends React.Component {
	getEntity() {
		return this.reloadedEntity ?? this.props.entity;
	}
	getEntityFields() {
		return this.getEntity().EntityFields;
	}
	getEntityDocumentTypes() {
		return this.getEntity().DocumentTypes;
	}
	getEntityCustomFields() {
		return this.getEntity().CustomFields;
	}
	getEntityRelatedCountryTypes() {
		return this.getEntity().RelatedCountryTypes;
	}
	getEntityComments() {
		return this.getEntity().Comments;
	}
	getEntityIdentificationDocuments() {
		return this.getEntity().IdentificationDocuments;
	}
	getSelfServiceIdentificationDocuments() {
		return this.getEntity().SelfServiceIdentificationDocuments;
	}
	getIdentificationDocumentsRequireUpload() {
		return this.getEntity().IdentificationDocumentsRequireUpload;
	}
	getEntityAddress() {
		return this.getEntity().Address;
	}

	constructor(props) {
		//const [submitFailed, setSubmitFailed] = React.useState(props.submitFailed);
		super(props);

		this.state = {
			form: {},
			formInvalid: false,
			submitDialogError: ''
		};
	}

	componentDidUpdate(prevProps) {
		this.reloadedEntity = null;
	}

	showSnackBar(message, alertType) {
		this.props.showSnackBar(message, alertType);
	}

	getFormFieldsFromFieldList(fieldList) {
		let fields = {};
		fieldList.forEach((field) => {
			let valueField = {
				[field.FieldCode]: field.Value ?? '',
			};
			if (field.Value && field.UseDatePicker) {
				valueField[field.FieldCode] = this.getDateObjectFromDayMonthYearFormat(field.Value);
			} else if (field.DataType === 1 && !field.UseDatePicker) {
				if (field.Value) {
					valueField = {
						[field.FieldCode]: {
							Day: field.Value[0] === '0' ? field.Value[1] : field.Value.substring(0, 2),
							Month: field.Value[3] === '0' ? field.Value[4] : field.Value.substring(3, 5),
							Year: field.Value.substring(6, 10),
						},
					};
				} else {
					valueField = {
						[field.FieldCode]: {
							Day: null,
							Month: null,
							Year: null,
						},
					};
				}
			}
			fields = { ...fields, ...valueField };
		});
		return fields;
	}

	getRelatedCoutriesFormFields(relatedCoutries) {
		let fields = {};
		relatedCoutries.forEach((relatedCountry) => {
			let valueField = {
				[relatedCountry.FieldCode]:
					this.props.countries.filter(
						(country) =>
							relatedCountry.Values.findIndex((relatedCountryValue) => relatedCountryValue === country.Code) !== -1
					) ?? null,
			};
			fields = { ...fields, ...valueField };
		});
		return fields;
	}

	getIdentificationDocumentsFormFields(property, identificationDocuments) {
		let fields = [];

		if (!identificationDocuments) return fields;

		identificationDocuments.forEach((identificationDocument) => {
			var identificationDocumentCopy = { ...identificationDocument };

			if (identificationDocumentCopy.DocumentExpiryDate && typeof identificationDocumentCopy.DocumentExpiryDate === 'string') {
				identificationDocumentCopy.DocumentExpiryDate = this.getDateObjectFromDayMonthYearFormat(identificationDocumentCopy.DocumentExpiryDate);
			}

			if (identificationDocumentCopy.DocumentIssueDate && typeof identificationDocumentCopy.DocumentIssueDate === 'string') {
				identificationDocumentCopy.DocumentIssueDate = this.getDateObjectFromDayMonthYearFormat(identificationDocumentCopy.DocumentIssueDate);
			}

			fields = [...fields, identificationDocumentCopy];
		});
		return { [property]: fields };
	}

	startIDVerification(forceNew = false) {
		var entity = this.getEntity();

		var route = routeHelpers.buildRoute(`/entities/${entity.EntityChangeRequestID}/id-verification?new=${forceNew}`);
		this.props.history.push(route);
	};

	componentDidMount() {
		const identificationDocuments = this.getIdentificationDocumentsFormFields(
			'IdentificationDocuments',
			this.getEntityIdentificationDocuments()
		);
		const selfServiceIdentificationDocuments = this.getIdentificationDocumentsFormFields(
			`SelfServiceIdentificationDocuments`,
			this.getSelfServiceIdentificationDocuments()
		);

		var entity = this.getEntity();

		const filteredDocs = entity.IdentificationDocuments?.filter(d => d.VerificationStatus !== 'Review' && 
				d.UserDecision !== 'Confirmed' && 
				d.UserDecision !== 'New' && 
				d.UserDecision !== 'Removed' && 
				d.UserDecision !== 'Updated' && 
				d.UserDecision !== 'Skipped' );

		var shouldVerify = this.props.idVerificationIsEnabled
			&& entity.EntityTypeCode === 'Individual'
			&& filteredDocs
			&& (entity.IdentificationDocuments.length === 0 || 
				entity.IdentificationDocuments.some(d => !d.UserDecision) ||
				entity.IdentificationDocuments.some(d => d.VerificationStatus === 'Declined' && d.UserDecision !== 'Removed') ||
				filteredDocs.length > 0
			)
			&& !this.props.idVerificationSkipped;

		if (shouldVerify) {
			this.startIDVerification();
			return;
		}

		const basicFields = this.getFormFieldsFromFieldList(this.getEntityFields());
		const customFields = this.getFormFieldsFromFieldList(this.getEntityCustomFields());
		const addressFields = this.getFormFieldsFromFieldList(this.getEntityAddress());
		const relatedCountries = this.getRelatedCoutriesFormFields(this.getEntityRelatedCountryTypes());
		const SelfServiceUserComment = this.getEntity().SelfServiceUserComment ?? '';

		this.setFormState({
			...basicFields,
			...customFields,
			...addressFields,
			...relatedCountries,
			...identificationDocuments,
			...selfServiceIdentificationDocuments,
			SelfServiceUserComment
		});
	}

	setformIdentificationDocuments() {
		const identificationDocuments = this.getIdentificationDocumentsFormFields(
			'IdentificationDocuments',
			this.getEntityIdentificationDocuments()
		);
		const selfServiceIdentificationDocuments = this.getIdentificationDocumentsFormFields(
			`SelfServiceIdentificationDocuments`,
			this.getSelfServiceIdentificationDocuments()
		);

		var formCopy = { ...this.getState().form };
		formCopy.identificationDocuments = identificationDocuments;
		formCopy.selfServiceIdentificationDocuments = selfServiceIdentificationDocuments;

		this.setState((state) => ({
			...state,
			form: formCopy
		}));
	}

	getDateObjectFromDayMonthYearFormat(date) {
		if (!date) {
			return null;
		}

		if (date.includes('/')) {
			const dateParts = date.split('/');
			return new Date(dateParts[2].split(' ')[0], dateParts[1] - 1, dateParts[0]);
		}
		else {
			return new Date(date);
		}
	}

	getDateAsString = (dateAsObject, useDatePicker) => {
		if (!dateAsObject) return null;

		if (!useDatePicker) {
			return this.mapCustomFieldDateToString(dateAsObject);
		} else {
			return this.mapCalendarDateToString(dateAsObject);
		}
	};

	mapCustomFieldDateToString(date) {
		//form validation requires a value to be set hence we return an invalid value
		if (!date.Day || !date.Month || !date.Year) return null;

		let day = date.Day.length < 2 ? `0` + date.Day : date.Day;
		let month = date.Month.length < 2 ? `0` + date.Month : date.Month;
		let year = date.Year;

		return year + `/` + month + `/` + day;
	}

	mapCalendarDateToString(date) {
		let day = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();

		return year + `/` + month + `/` + day;
	}

	//----------STATE SETTING----------

	setFormState(fields) {
		this.setState((state) => ({
			...state,
			form: fields,
		}));
	}

	handleExpandClick = (expanded, sectionName) => {
		this.props.actions.selfService.setExpandedSections({
			...this.props.expandedSections,
			[sectionName]: expanded
		});
	};

	setFieldState(fieldCode, value) {
		this.props.fieldChange();
		this.setState((state) => ({
			...state,
			form: {
				...state.form,
				[fieldCode]: value,
			},
		}));
	}

	setDateFieldState(fieldCode, dateType, value) {
		this.props.fieldChange();
		this.setState((state) => ({
			...state,
			form: {
				...state.form,
				[fieldCode]: {
					...state.form[fieldCode],
					[dateType]: value,
				},
			},
		}));
	}

	setFormInvalidState(errored) {
		this.setState((state) => ({
			...state,
			formInvalid: errored,
		}));
	}

	setSubmitDialogError(error) {
		this.setState((state) => ({
			...state,
			submitDialogError: error,
		}));
	}

	isFieldNew(item) {
		if (this.props.newLoadedFields.length) {
			return this.props.newLoadedFields.filter((field) => field.FieldCode === item.FieldCode).length > 0;
		}

		return false;
	}

	//------------FORM VALIDATION-------

	checkIfDateFieldsDirty(fieldCode) {
		let dateField = this.state.form[fieldCode];

		if (dateField && (dateField.Day || dateField.Month || dateField.Year)) {
			return true;
		}

		return false;
	}

	validateField = (field, fieldValue, isSubmitting) => {

		// 1. Validate Field Exists.
		if (!field) {
			return;
		}

		// 2. Validate field type exists and is valid.
		var fieldType = Constants.FIELDDATATYPES.find(x => x.value === field.DataType.toLocaleString());

		if (!fieldType || !fieldType.value || !fieldType.label) {
			return { [field.FieldCode]: 'Type of field is invalid.' }
		}

		// 3. Validate mandatory fields.
		if (fieldType.label === "Document") {
			if (field.IsMandatory && isSubmitting && field.SelfServiceDocuments && field.SelfServiceDocuments.length === 0) {
				return { [field.FieldCode]: `There are no uploads for this mandatory document.` };
			}
		}
		else {
			// NEED TO CHECK WITH DEFAULT VALUE HERE
			if (field.IsMandatory && isSubmitting && (!fieldValue || (typeof fieldValue === 'string' && !fieldValue.trim()) || (Array.isArray(fieldValue) && fieldValue.length === 0))) {
				return { [field.FieldCode]: `This field is mandatory.` };
			}
		}

		// 4. Validate FieldValue;
		switch (fieldType.label) {
			case "String":
				if (field && fieldValue) {
					if (field.MinLength && field.Length < field.MinLength) {
						return { [field.FieldCode]: `String must exceeded the minimum characters of ${field.MinLength}.` };
					}

					if (field.MaxLength && field.Length > field.MaxLength) {
						return { [field.FieldCode]: `String must not exceed the maximum characters of ${field.MaxLength}.` };
					}
				}
				return null;
			case "Date":
				// if field is set and day or month or year is set, we are expecting the full date or else its invalid.
				if (field && fieldValue) {
					var timestamp = Date.parse(fieldValue);
					var dateField = new Date(timestamp);

					if (fieldValue == "INVALID") {
						return { [field.FieldCode]: 'Date is invalid.' };
					}

					if (!dateField.getDate()) {
						return { [field.FieldCode]: 'Day is invalid.' };
					}

					if (!dateField.getMonth() < 0 && dateField.getMonth() > 11) {
						return { [field.FieldCode]: 'Month is invalid.' };
					}

					if (!dateField.getFullYear()) {
						return { [field.FieldCode]: 'Year is invalid.' };
					}

					if (dateField.getDate() && dateField.getMonth() && dateField.getFullYear()) {
						let daysInMonth = this.getDaysInMonth(parseInt(dateField.getMonth()) + 1, parseInt(dateField.getFullYear()));

						if (daysInMonth < dateField.getDate()) {
							return { [field.FieldCode]: 'Day is invalid.' };
						}

						if (field.MinDateValue && dateField < field.MinDateValue) {
							return { [field.FieldCode]: `Date must exceed the minimum date of ${field.MinDateValue}.` };
						}

						if (field.MinDateValue && dateField < field.MaxDateValue) {
							return { [field.FieldCode]: `Date must not exceed the maximum date of ${field.MaxDateValue}.` };
						}
					}
				}
				return null;
			case "Country":
			case "Nationality":
				if (field && fieldValue) {
					var country = this.props.countries.filter((country) => country.Code === fieldValue);

					if (!country) {
						return { [field.FieldCode]: 'The country saved is not valid.' };
					}
				}
				return null;
			case "Document":
				if (field && fieldValue) {
					var errors = {}
					fieldValue.forEach(function (ssd) {
						if (!Number.isInteger(ssd)) {
							errors[field.FieldCode] = 'The document ID is not valid.';
						}
					});
					return errors;
				}
				break;
			case "IDDocument":
				//NOT USED NEED TO REMOVE
				break;
			case "Choice":
				if (field && fieldValue) {
					if (!field.Options.find(x => x.Key === fieldValue)) {
						return { [field.FieldCode]: 'The choice selected is not valid.' };
					}
				}
				return null;
			case "MultiChoice":
				return { [field.FieldCode]: 'Multi Choice Validation not supported.' };
			case "MultiCountry":
				if (field && fieldValue && Array.isArray(fieldValue)) {
					var errors = {}
					fieldValue.forEach((val) => {
						var country = this.props.countries.filter((country) => country.Code === val);

						if (!country) {
							errors[field.FieldCode] = 'The country saved is not valid.';
						}
					});
					return errors;
				}
			case "Integer":
				if (field && fieldValue) {
					if (isNaN(Number(fieldValue)) || !Number.isInteger(Number(fieldValue))) {
						return { [field.FieldCode]: 'The integer inputted is not valid.' };
					}

					var integer = parseInt(fieldValue);

					if (field.MinIntValue && integer < field.MinIntValue) {
						return { [field.FieldCode]: `Integer must exceed the maximum vlaue of ${field.MinIntValue}.` };
					}

					if (field.MaxIntValue && integer < field.MaxIntValue) {
						return { [field.FieldCode]: `Integer must not exceed the maximum value of ${field.maxIntValue}.` };
					}
				}
				return null;
			case "Boolean":
				if (field && fieldValue) {
					if (fieldValue !== "true" && fieldValue !== "false") {
						return { [field.FieldCode]: 'The data inputted is not a valid.' };
					}
				}
				break;
		}
	}

	validateIdentificationDocuments = async (idDocuments, isSubmitting) => {
		let errors = {};
		var idVerificationEnabled = await this.props.actions.selfService.checkIfIDVerificationIsEnabled();

		if (idVerificationEnabled && isSubmitting) {
			if (idDocuments.filter(d => d.UserDecision !== 'Removed').length === 0) {
				//const firstRemoved = idDocuments.filter(d => d.UserDecision === 'Removed')[0];
				errors['IdentificationDocuments'] = 'At least one ID document must be submitted.';
				//errors[`IdentificationDocument${firstRemoved.DocumentID}`] = 'At least one ID document must be submitted.';
			} else if (!idDocuments.some(d => d.VerificationStatus === 'Verified' || d.VerificationStatus === 'Review' || d.UserDecision === 'New' || d.UserDecision === 'Updated')) {
				//const firstRemoved = idDocuments[0];
				//errors[`IdentificationDocument${firstRemoved.DocumentID}`] = 'At least one ID document must be verified or in review. Please add one by clicking the Add ID Document button below.';
				errors['IdentificationDocuments'] = 'At least one ID document must be verified or in review. Please add one by clicking the Add ID Document button below.';
			} else if (idDocuments.some(d => d.UserDecision === 'Skipped')) {
				errors['IdentificationDocuments'] = 'Please verify pending ID Document.';
			}
		}

		for (let idDoc of idDocuments) {
			if (idDoc.UserDecision === "Removed" || idDoc.UserDecision === 'New') continue;

			const idDocumentSectionId = `IdentificationDocument${idDoc.DocumentID}`;

			if (!idDoc.DocumentID) {
				errors[idDocumentSectionId] = 'Document ID is mandatory.';
				continue;
			}

			if (!idDoc.IssuingCountry) {
				errors[idDocumentSectionId] = 'Issuing Country is mandatory.';
				continue;
			}

			if (idDoc.Expires && !idDoc.DocumentExpiryDate) {
				errors[idDocumentSectionId] = 'Document Expiry date is mandatory as the ID document is marked as expires.';
				continue;
			}

			if (idDoc.DocumentExpiryDate) {
				var error = this.validateIdCardFieldDate(idDocumentSectionId, idDoc.DocumentExpiryDate);
				if (error) {
					errors[idDocumentSectionId] = error;
					continue;
				}
			}
			if (idDoc.DocumentIssueDate) {
				var error = this.validateIdCardFieldDate(idDocumentSectionId, idDoc.DocumentIssueDate);
				if (error) {
					errors[idDocumentSectionId] = error;
					continue;
				}
			}

			if (isSubmitting && this.getIdentificationDocumentsRequireUpload() && !idDoc.BaseDocumentID) {
				errors[idDocumentSectionId] = 'Document upload is mandatory for each ID document.';
				continue;
			}
		}

		var result = Object.keys(errors).length ? errors : null;
		return result;
	};

	validateIdCardFieldDate = (idDocumentSectionId, formDate) => {
		var timestamp = Date.parse(formDate);
		var dateField = new Date(timestamp);

		if (!dateField.getDate()) {
			return { [idDocumentSectionId]: 'Day is invalid.' };
		}

		if (!dateField.getMonth() < 0 && dateField.getMonth() > 11) {
			return { [idDocumentSectionId]: 'Month is invalid.' };
		}

		if (!dateField.getFullYear()) {
			return { [idDocumentSectionId]: 'Year is invalid.' };
		}

		if (dateField.getDate() && dateField.getMonth() && dateField.getFullYear()) {
			let daysInMonth = this.getDaysInMonth(parseInt(dateField.getMonth() + 1), parseInt(dateField.getFullYear()));

			if (daysInMonth < dateField.getDate()) {
				return { [idDocumentSectionId]: 'Day is invalid.' };
			}
		}
	};

	//----------EVENT HANDLERS------------

	checkIfFormValid = async (requestObject, isSubmitting) => {
		var validation = "";

		let errors = {};

		if (!requestObject) {
			return validation = "error";
		}

		this.getEntityFields().forEach((field) => {
			const error = this.validateField(field, requestObject["EntityFields"][field.FieldCode], isSubmitting);
			if (error) {
				errors = Object.assign(errors, error);
			}
		});

		this.getEntityAddress().forEach((field) => {
			const error = this.validateField(field, requestObject["Address"][field.FieldCode], isSubmitting);

			if (error) {
				errors = Object.assign(errors, error);
			}
		});

		if (Object.keys(errors).length > 0 && isSubmitting) {
			validation = "error";
		}

		this.getEntityCustomFields().forEach((field) => {
			const error = this.validateField(field, requestObject["CustomFields"][field.FieldCode], isSubmitting);

			if (error) {
				errors = Object.assign(errors, error);
			}
		});

		this.getEntityRelatedCountryTypes().forEach((field) => {
			const error = this.validateField(field, requestObject["RelatedCountryTypes"][field.FieldCode], isSubmitting);

			if (error) {
				errors = Object.assign(errors, error);
			}
		});

		this.getEntityDocumentTypes().forEach((field) => {
			const error = this.validateField(field, requestObject["DocumentTypes"][field.FieldCode], isSubmitting);

			if (error) {
				errors = Object.assign(errors, error);
			}
		});

		if (requestObject["IdentificationDocuments"] && this.getEntity().EntityTypeCode === EntityTypeCodes.Individual) {
			const inScopeIdCardErrors = await this.validateIdentificationDocuments(requestObject["IdentificationDocuments"], isSubmitting);
			if (inScopeIdCardErrors) {
				errors = Object.assign(errors, inScopeIdCardErrors);
			}
		}

		this.props.setFieldErrors(errors);

		if (Object.keys(errors).length) {
			this.props.actions.selfService.setExpandedSections({
				'EntityFields': true,
				'EntityAddress': true,
				'EntityCustomFields': true,
				'EntityRelatedCountries': true,
				'EntityDocumentTypes': true,
				'EntityIdentificationDocuments': true,
				'CommentsHistory': true
			});

			this.setFormInvalidState(true);

			if (!validation) {
				validation = "false";
			}

		} else {
			validation = "true";
		}

		return validation;
		// If true, passed mandatory/optional fields and values are valid
		// If false, some fields did not pass mandatory/optional or values are not valid
		// If error, basic entity fields and address fields did not pass the validation.
	}

	handleFormSubmitWithConfirmation = async () => {
		if (!this.state.form.SelfServiceUserComment) {
			this.setSubmitDialogError('*Please specify reason for an incomplete form submission.');

			return;
		}

		this.setFormInvalidState(false);
		this.setSubmitDialogError('');
		this.props.showSubmitDialog(false);
		this.props.submitForm(await this.mapRequestObject());
	};

	handleFormSubmit = async (event) => {
		event.preventDefault();
		this.setFormInvalidState(false);

		const requestObject = await this.mapRequestObject();

		if (await this.checkIfFormValid(requestObject, false) !== "true") {
			this.props.submitFailed(true);
			return;
		}

		this.props.saveForm(requestObject, true)
			.then(async (reloadedEntity) => {
				if (reloadedEntity) {
					this.reloadedEntity = reloadedEntity;
				}
				const isFormValidForSubmit = await this.checkIfFormValid(requestObject, true);

				if (isFormValidForSubmit == "error") {
					this.props.submitFailed(true);
					return;
				}
				else if (isFormValidForSubmit == "false") {
					this.props.showSubmitDialog(true);
					return;
				}

				this.props.submitForm(requestObject);
			})
			.catch((errors) => {
				this.props.setFieldErrors(errors);
			});

	};

	handleFormSave = async () => {
		this.setFormInvalidState(false);

		var requestObject = await this.mapRequestObject();
		if (!await this.checkIfFormValid(requestObject, false)) {
			return;
		}

		this.props.saveForm(requestObject)
			.then()
			.catch((errors) => {
				this.props.setFieldErrors(errors);
			});
	};

	buildEmptySelfServiceSaveRequestObject() {
		var object = {
			EntityFields: {},
			CustomFields: {},
			Address: {},
			RelatedCountryTypes: {},
			DocumentTypes: {},
		};

		if (this.getEntity().EntityTypeCode === EntityTypeCodes.Individual) {
			object.IdentificationDocuments = [];
		}

		return object;
	}

	mapRequestObject = async () => {
		let formObject = { ...this.state.form };

		let requestObject = this.buildEmptySelfServiceSaveRequestObject();

		requestObject.SelfServiceUserComment = formObject.SelfServiceUserComment;

		this.mapFieldsFromFormObjectToRequestObject(this.getEntityFields(), formObject, 'EntityFields', requestObject);
		this.mapFieldsFromFormObjectToRequestObject(this.getEntityCustomFields(), formObject, 'CustomFields', requestObject);
		this.mapFieldsFromFormObjectToRequestObject(this.getEntityAddress(), formObject, 'Address', requestObject);
		this.mapFieldsFromFormObjectToRequestObject(this.getEntityRelatedCountryTypes(), formObject, 'RelatedCountryTypes', requestObject);
		this.mapFieldsFromFormObjectToRequestObject(this.getEntityDocumentTypes(), formObject, 'DocumentTypes', requestObject);

		var entityType = this.getEntity().EntityTypeCode;
		if (entityType === EntityTypeCodes.Individual) {
			var idVerificationEnabled = await this.props.actions.selfService.checkIfIDVerificationIsEnabled();
			if (idVerificationEnabled) {
				requestObject["IdentificationDocuments"] = this.mapIdDocumentsToRequestObject(
					[
						...formObject.IdentificationDocuments
					]
				);

			} else {
				requestObject["IdentificationDocuments"] = this.mapIdDocumentsToRequestObject(
					[
						...formObject.IdentificationDocuments,
						...formObject.SelfServiceIdentificationDocuments
					]
				);
			}
		}
		else if (entityType === EntityTypeCodes.Company) {
			// nothing yet here
		}
		else if (entityType === EntityTypeCodes.Trust) {
			// nothing yet here
		}
		else if (entityType === EntityTypeCodes.Organisation) {
			// nothing yet here
		}

		return requestObject;
	};

	mapFieldsFromFormObjectToRequestObject(fieldList, formObject, prop, requestObject) {
		fieldList.forEach((field) => {
			var fieldType = Constants.FIELDDATATYPES.find(x => x.value === field.DataType.toLocaleString());
			switch (fieldType.label) {
				case "Date":
					var dateAsString = this.getDateAsString(formObject[field.FieldCode], field.UseDatePicker);
					dateAsString = dateAsString ? dateAsString : null;
					requestObject[prop] = { ...requestObject[prop], [field.FieldCode]: dateAsString };
					break;
				case "String":
					var stringValue = formObject[field.FieldCode] ? formObject[field.FieldCode] : null;
					requestObject[prop] = { ...requestObject[prop], [field.FieldCode]: stringValue };
					break;
				case "Document":
					var documentIds = field.SelfServiceDocuments ? field.SelfServiceDocuments.map((doc) => doc.BaseDocumentId) : [];
					requestObject[prop] = {
						...requestObject[prop],
						[field.FieldCode]: documentIds,
					};
					break;
				case "IDDocument":
					//NOT USED NEED TO REMOVE
					break;
				case "MultiCountry":
					var countries = formObject[field.FieldCode].map((country) => country.Code ? country.Code : country);
					requestObject[prop] = {
						...requestObject[prop],
						[field.FieldCode]: countries,
					};
					break;
				case "Country":
				case "Nationality":
				case "Choice":
				case "Boolean":
				case "Integer":
				default:
					var propValue = formObject[field.FieldCode] ? formObject[field.FieldCode] : null;
					requestObject[prop] = { ...requestObject[prop], [field.FieldCode]: propValue };
					break;
			}
		});
	}

	mapIdDocumentsToRequestObject(idDocs) {
		const result = [];

		if (!idDocs) return result;

		idDocs.forEach((idDoc) => {
			result.push({
				DocumentExpiryDate: this.getDateAsString(idDoc.DocumentExpiryDate, true),
				DocumentID: idDoc.DocumentID,
				DocumentIssueDate: this.getDateAsString(idDoc.DocumentIssueDate, true),
				DocumentType: idDoc.DocumentType,
				Expires: idDoc.Expires,
				IssuingCountry: idDoc.IssuingCountry,
				BaseDocumentID: idDoc.SelfServiceDocument ? idDoc.SelfServiceDocument.BaseDocumentId : null,
				UserDecision: idDoc.UserDecision,
				ID: idDoc.ID ? idDoc.ID : null,
				TempID: idDoc.TempID ? idDoc.TempID : null,
				VerificationStatus: idDoc.VerificationStatus
			});
		});

		return result;
	}

	mapFieldCodeToSection = (fieldCode) => {
		if (this.props.entity.EntityFields && this.props.entity.EntityFields.some(x => x.FieldCode === fieldCode)) {
			return "EntityFields";
		}
		else if (this.props.entity.DocumentTypes && this.props.entity.DocumentTypes.some(x => x.FieldCode === fieldCode)) {
			return "EntityDocumentTypes";
		}
		else if (this.props.entity.CustomFields && this.props.entity.CustomFields.some(x => x.FieldCode === fieldCode)) {
			return "EntityCustomFields";
		}
		else if (this.props.entity.RelatedCountryTypes && this.props.entity.RelatedCountryTypes.some(x => x.FieldCode === fieldCode)) {
			return "EntityRelatedCountries";
		}
		else if (this.props.entity.Comments && this.props.entity.Comments.some(x => x.FieldCode === fieldCode)) {
			return "CommentsHistory";
		}
		else if (this.props.entity.IdentificationDocuments && this.props.entity.IdentificationDocuments.some(x => x.FieldCode === fieldCode)) {
			return "EntityIdentificationDocuments";
		}
		else if (this.props.entity.selfServiceIdentificationDocuments && this.props.entity.selfServiceIdentificationDocuments.some(x => x.FieldCode === fieldCode)) {
			return "EntityIdentificationDocuments";
		}
		else if (this.props.entity.Address && this.props.entity.Address.some(x => x.FieldCode === fieldCode)) {
			return "EntityAddress";
		}
	}

	mapFieldCodeToErrorSection = (fieldCode) => {
		if (this.props.entity.EntityFields && this.props.entity.EntityFields.some(x => x.FieldCode === fieldCode)) {
			return "EntityFields";
		}
		else if (this.props.entity.DocumentTypes && this.props.entity.DocumentTypes.some(x => x.FieldCode === fieldCode)) {
			return "DocumentTypes";
		}
		else if (this.props.entity.CustomFields && this.props.entity.CustomFields.some(x => x.FieldCode === fieldCode)) {
			return "CustomFields";
		}
		else if (this.props.entity.RelatedCountryTypes && this.props.entity.RelatedCountryTypes.some(x => x.FieldCode === fieldCode)) {
			return "RelatedCountryTypes";
		}
		else if (this.props.entity.IdentificationDocuments && this.props.entity.IdentificationDocuments.some(x => x.FieldCode === fieldCode)) {
			return "IdentificationDocuments";
		}
		else if (this.props.entity.selfServiceIdentificationDocuments && this.props.entity.selfServiceIdentificationDocuments.some(x => x.FieldCode === fieldCode)) {
			return "SelfServiceIdentificationDocuments";
		}
		else if (this.props.entity.Address && this.props.entity.Address.some(x => x.FieldCode === fieldCode)) {
			return "Address";
		}
	}


	handleErrorClear(fieldCode) {
		if (this.state.formInvalid || Object.keys(this.props.fieldErrors).length) {
			this.props.clearFieldError(fieldCode, this.mapFieldCodeToErrorSection(fieldCode));
			this.setFormInvalidState(false);
		}
	}

	handleChange = (event) => {
		this.setFieldState(event.target.name, event.target.value);
		this.handleErrorClear(event.target.name);
	};

	handleChoiceChange = (event) => {
		let choiceValues = [];

		if (this.state.form[event.target.name]) {
			choiceValues = [...this.state.form[event.target.name]];

			if (!choiceValues.includes(event.target.value)) {
				choiceValues.push(event.target.value);
			} else {
				choiceValues = choiceValues.filter((x) => x !== event.target.value);
			}
		} else {
			choiceValues.push(event.target.value);
		}

		this.setFieldState(event.target.name, choiceValues);
		this.handleErrorClear(event.target.name);
	};

	handleSelectChange = (fieldCode, event, value) => {
		this.setFieldState(fieldCode, value ? value : '');
		this.props.clearFieldError(fieldCode, this.mapFieldCodeToErrorSection(fieldCode));
	};

	handleDatePickChange = (fieldCode, value) => {
		let datePickValue = value ? value : '';

		this.setFieldState(fieldCode, datePickValue);
		this.handleErrorClear(fieldCode);
	};

	handleDateSelectChange = (fieldCode, dateType, event, value) => {
		let fieldValue;
		if (dateType === 'Month') {
			fieldValue = value ? value.value : '';
		} else {
			fieldValue = value;
		}

		this.setDateFieldState(fieldCode, dateType, fieldValue);
		this.handleErrorClear(fieldCode);
	};

	handleFileChange = (event) => {
		//TODO -
		//validation
		//1. save files to server,
		//2. retrieve their IDs - as saved on server
		//3. attach IDs to form state

		/*
	 const formData = new FormData();
	  for (var x = 0; x < files.length; x++) {
		formData.append("attachments", files[x]);
	  }

	  POST formData
	  attachmentIds = response.data     
	*/
	};

	handleSubmitDialogClose = () => {
		this.setSubmitDialogError('');

		var firstFieldCode = Object.keys(this.props.fieldErrors)[0];

		if (firstFieldCode) {
			var section = this.mapFieldCodeToSection(firstFieldCode);

			if (section) {
				this.handleExpandClick(true, section)
			}
		}

		this.props.showSubmitDialog(false);
	};

	//----------DATE UTILITY------------

	getYears() {
		let currentYear = new Date().getFullYear(),
			years = [];
		let startYear = currentYear - 100;
		while (startYear <= currentYear + 20) {
			years.push(startYear++);
		}
		return years.map(String);
	}

	getDaysInMonth(month, year) {
		return new Date(year, month, 0).getDate();
	}

	getNumberArray(start, end) {
		let numbers = [];
		while (start <= end) {
			numbers.push(start++);
		}
		return numbers.map(String);
	}

	getDayArray(fieldCode) {
		let dateField = this.state.form[fieldCode];

		if (dateField && dateField.Month && dateField.Year) {
			if (dateField.Month !== '' || dateField.Year !== '') {
				return this.getNumberArray(1, this.getDaysInMonth(parseInt(dateField.Month), parseInt(dateField.Year)));
			}
		}

		return this.getNumberArray(1, 31);
	}

	//------------FIELD POPULATION-------------

	populateDateField = (item, itemFieldError) => {
		if (item.UseDatePicker) {
			return (
				<DynamicDatePickControl
					field={item}
					eventHandle={this.handleDatePickChange.bind(this, item.FieldCode)}
					fieldError={itemFieldError}
					hideField={this.hideDateFieldForDependency(item)}
					value={this.state.form[item.FieldCode] ? this.state.form[item.FieldCode] : null}
				/>
			);
		} else {
			return (
				<FormGroup className='entity-date-field'>
					<fieldset className='entity-fieldset'>
						<Typography component='legend' color='primary'>
							<legend>
								{item.IsMandatory ? '*' : ''}
								{item.FieldName}
							</legend>
						</Typography>
						<Typography variant='body2' color='error' style={{ marginTop: 8 }}>
							{itemFieldError}
						</Typography>
						<p dangerouslySetInnerHTML={{ __html: item.HelpText }}></p>
						<Grid container alignItems='center' spacing={2}>
							<Grid item className='date-field-day' xs={12} sm={12} md={4}>
								<DynamicDateField
									field={item}
									fieldOptions={this.getDayArray(item.FieldCode)}
									fieldOptionLabels={(option) => option}
									dateType={['Day', 'number', this.state.form[item.FieldCode].Day]}
									error={itemFieldError ? true : false}
									isRequired={item.IsMandatory || this.checkIfDateFieldsDirty(item.FieldCode)}
									eventHandle={this.handleDateSelectChange.bind(this, item.FieldCode, 'Day')}
								/>
							</Grid>
							<Grid item className='date-field-month' xs={12} sm={12} md={4}>
								<DynamicDateField
									field={item}
									fieldOptions={Constants.MONTHS}
									fieldOptionLabels={(option) => {
										return option && option.label ? option.label : ``;
									}}
									dateType={[
										'Month',
										'text',
										Constants.MONTHS.find((month) => month.value === this.state.form[item.FieldCode].Month)
											? Constants.MONTHS.find((month) => month.value === this.state.form[item.FieldCode].Month)
											: null,
									]}
									error={itemFieldError ? true : false}
									isRequired={item.IsMandatory || this.checkIfDateFieldsDirty(item.FieldCode)}
									eventHandle={this.handleDateSelectChange.bind(this, item.FieldCode, 'Month')}
								/>
							</Grid>
							<Grid item className='date-field-year' xs={12} sm={12} md={4}>
								<DynamicDateField
									field={item}
									fieldOptions={this.getYears()}
									fieldOptionLabels={(option) => option}
									dateType={['Year', 'number', this.state.form[item.FieldCode].Year]}
									error={itemFieldError ? true : false}
									isRequired={item.IsMandatory || this.checkIfDateFieldsDirty(item.FieldCode)}
									eventHandle={this.handleDateSelectChange.bind(this, item.FieldCode, 'Year')}
								/>
							</Grid>
						</Grid>
					</fieldset>
				</FormGroup>
			);
		}
	};

	retrieveFieldErrorFromFieldCode = (fieldCode) => {
		let itemFieldError = null;
		let section = this.mapFieldCodeToErrorSection(fieldCode);

		if (this.props.fieldErrors[fieldCode]) {
			return this.props.fieldErrors[fieldCode];
		}
		else if (this.props.fieldErrors && this.props.fieldErrors[section] && Array.isArray(this.props.fieldErrors[section])) {
			let errorItem = this.props.fieldErrors[section].find(x => x.FieldCode === fieldCode);

			if (errorItem && errorItem['ErrorMessage']) {
				itemFieldError = errorItem['ErrorMessage'];
			}
		}

		return itemFieldError;
	}

	populateField = (item) => {
		let itemFieldError = item ? this.retrieveFieldErrorFromFieldCode(item.FieldCode) : null;

		var fieldType = Constants.FIELDDATATYPES.find(x => x.value === item.DataType.toLocaleString());
		switch (fieldType.label) {
			case "String":
				return (
					<DynamicTextField
						field={item}
						eventHandle={this.handleChange}
						fieldProps={{ maxLength: item.MaxLength }}
						fieldError={itemFieldError}
					/>
				);
			case "Date":
				return this.populateDateField(item, itemFieldError);
			case "Country":
				return (
					<DynamicAutoComplete
						field={item}
						records={this.props.countries}
						fieldOptions={this.props.countries.map((c) => c.Code)}
						fieldOptionLabels={(option) =>
							option && this.props.countries.length > 0
								? this.props.countries.filter((c) => c.Code == option)[0].Name
								: ''
						}
						allowMultiple={false}
						isRequired={item.IsMandatory}
						defaultValue={item.Value}
						eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
						fieldError={itemFieldError}
					/>
				);
			case "Nationality":
				return (
					<DynamicAutoComplete
						field={item}
						records={this.props.nationalities}
						fieldOptions={this.props.nationalities.map((c) => c.Code)}
						fieldOptionLabels={(option) =>
							option && this.props.nationalities.length > 0
								? this.props.nationalities.filter((c) => c.Code == option)[0].Name
								: ''
						}
						allowMultiple={false}
						isRequired={item.IsMandatory}
						defaultValue={item.Value}
						eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
						fieldError={itemFieldError}
					/>
				);
			case "Document":
				return <DynamicFileControl field={item} eventHandle={this.handleFileChange} fieldError={itemFieldError} />;
			case "ID Document":
				// WHAT DO WE DO HERE
				return '';
			case "Choice":
				if (item.Options.length > 5) {
					return (
						<DynamicAutoComplete
							field={item}
							fieldOptions={item.Options.map((o) => o.Key)}
							fieldOptionLabels={(option) => (option ? item.Options.filter((o) => o.Key == option)[0].Value : '')}
							allowMultiple={false}
							defaultValue={item.Value}
							isRequired={item.IsMandatory}
							eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
							fieldError={itemFieldError}
						/>
					);
				} else {
					return (
						<DynamicRadioControl
							isBoolean={false}
							field={item}
							defaultValue={item.Value}
							eventHandle={this.handleChange}
							fieldError={itemFieldError}
						/>
					);
				}
			case "MultiCountry":
				return (
					<DynamicAutoComplete
						field={item}
						records={this.props.countries}
						fieldOptions={this.props.countries}
						fieldOptionLabels={(option) => option.Name}
						allowMultiple={true}
						isRequired={false}
						eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
						fieldError={itemFieldError}
					/>
				);
			case "Boolean":
				return (
					<DynamicRadioControl
						isBoolean={true}
						field={item}
						defaultValue={item.Value}
						eventHandle={this.handleChange}
						fieldError={itemFieldError}
					/>
				);
			case "MultiChoice":
				if (item.Options.length > 5) {
					return (
						<DynamicAutoComplete
							field={item}
							fieldOptions={item.Options}
							fieldOptionLabels={(option) => option}
							allowMultiple={true}
							isRequired={false}
							eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
							fieldError={itemFieldError}
						/>
					);
				} else {
					return (
						<DynamicCheckboxControl field={item} eventHandle={this.handleChoiceChange} fieldError={itemFieldError} />
					);
				}
			case "Integer":
				return (
					<DynamicTextField
						field={item}
						eventHandle={this.handleChange}
						fieldError={itemFieldError}
						fieldProps={{
							min: [item.MinIntValue],
							max: [item.MaxIntValue],
							type: 'number',
						}}
					/>
				);
			default:
				return <div></div>;
		}
	};

	hasIdentificationDocumentExpiresPropertyName(fieldCode) {
		const prefixPropertyName = `IdentificationDocument`;
		const suffixPropertyName = `ExpiryDate`;

		if (fieldCode.indexOf(prefixPropertyName) !== -1 && fieldCode.indexOf(suffixPropertyName) !== -1) {
			let numberOfDocument = fieldCode.replaceAll(prefixPropertyName, '');
			numberOfDocument = numberOfDocument.replaceAll(suffixPropertyName, '');
			return prefixPropertyName + numberOfDocument + `Expires`;
		}
		return null;
	}

	hideDateFieldForDependency(item) {
		const identificationDocumentPropertyName = this.hasIdentificationDocumentExpiresPropertyName(item.FieldCode);
		return identificationDocumentPropertyName ? this.state.form[identificationDocumentPropertyName] === 'false' : false;
	}

	generateFormField(item) {
		return (
			<div id={item.FieldCode} className='form-entity-field' key={item.FieldCode}>
				<div className={this.isFieldNew(item) ? 'new-loaded' : ''}>{this.populateField(item)}</div>
			</div>
		);
	}

	buildRelatedCountryField(item, itemFieldErrors) {
		return (
			<div key={item.FieldCode}>
				<DynamicAutoComplete
					field={item}
					fieldOptions={this.props.countries.map((c) => c.Code)}
					fieldOptionLabels={
						(option) => {
							if (!option || this.props.countries.length == 0) return '';
							return this.props.countries.filter((c) => c.Code == option || c.Code == option.Code)[0].Name;
						}
					}
					records={this.props.countries}
					allowMultiple={true}
					isRequired={item.IsMandatory}
					eventHandle={this.handleSelectChange.bind(this, item.FieldCode)}
					fieldError={this.retrieveFieldErrorFromFieldCode(item.FieldCode)}
					defaultValue={this.state.form[item.FieldCode]}
				/>
			</div>
		);
	}

	buildFormSectionFromFieldList(fieldList) {
		return fieldList.map((item) => this.generateFormField(item));
	}

	buildBasicFieldsFormSection() {
		return <div>{this.buildFormSectionFromFieldList(this.getEntityFields())}</div>;
	}

	buildCustomFieldsFormSection() {
		return <div>{this.buildFormSectionFromFieldList(this.getEntityCustomFields())}</div>;
	}
	buildAddressFieldsFormSection() {
		return <div>{this.buildFormSectionFromFieldList(this.getEntityAddress())}</div>;
	}

	buildRelatedCoutriesFormSection() {
		return this.getEntityRelatedCountryTypes().map((item) => this.buildRelatedCountryField(item));
	}

	setIdentificationDocumentsFormState(property, newIdentificationDocument, index) {
		const newIdentificationDocuments = Object.assign([], this.state.form[property], {
			[index]: newIdentificationDocument,
		});
		this.setFieldState(property, newIdentificationDocuments);
	}

	addSelfServiceIdentificationDocumentsFormState(newIdentificationDocument) {
		const newIdentificationDocuments = [
			...this.state.form.SelfServiceIdentificationDocuments,
			newIdentificationDocument,
		];
		this.setSelfServiceIdentificationDocuments(newIdentificationDocuments);
	}

	removeIdentificationDocument(identificationDocumentToRemove) {
		const newIdentificationDocuments = this.state.form.SelfServiceIdentificationDocuments.filter(
			(idDoc) => idDoc !== identificationDocumentToRemove
		);
		this.setSelfServiceIdentificationDocuments(newIdentificationDocuments);
	}

	setSelfServiceIdentificationDocuments(newIdentificationDocuments) {
		this.setFieldState(`SelfServiceIdentificationDocuments`, newIdentificationDocuments);
	}

	buildIdentificationDocumentsForm() {
		if (this.props.idVerificationIsEnabled) {
			return (
				<fieldset className='entity-fieldset'>
					<Typography component='legend' color='primary'>
						<legend>Identification Documents</legend>
					</Typography>
					<Typography color='textSecondary' gutterBottom>
						{/* Click <b onClick={() => this.startIDVerification()} style={{ cursor: 'pointer' }}>here</b> to restart the ID verification process. */}
						{this.state.form.IdentificationDocuments && this.state.form.IdentificationDocuments.map((item, index) => (
							<div key={item.FieldCode} id={item.FieldCode}>
								{item.DocumentTypeName && item.VerificationStatus &&
									<IdentificationDocument
										setFieldState={(newIdentificationDocument) =>
											this.setIdentificationDocumentsFormState(`IdentificationDocuments`, newIdentificationDocument, index)
										}
										countriesList={this.props.countries}
										identificationDocument={item}
										addingMode={false}
										showSnackBar={this.showSnackBar}
										setFieldError={(error) => {
											this.props.clearFieldError(item.FieldCode, this.mapFieldCodeToErrorSection(item.FieldCode));

											if (this.props.fieldErrors[item.FieldCode]) {
												this.props.setFieldErrors({ ...this.props.fieldErrors, [item.FieldCode]: error });
											}
										}}
										fieldError={this.retrieveFieldErrorFromFieldCode(`IdentificationDocument${item.DocumentID}`)}
										readOnlyMode={true}
									/>
								}
								{item.UserDecision === 'New' && !item.DocumentType && (!item.VerificationStatus || item.VerificationStatus === 'Pending') && <div>You have uploaded a new document that is currently being verified. <br/><br/></div>}
							</div>
						))}
						{this.state.form.IdentificationDocuments &&
							(!this.state.form.IdentificationDocuments.filter(d => d.UserDecision !== 'Removed').some(d => d.VerificationStatus === 'Verified' || d.VerificationStatus === 'Review' || d.UserDecision === 'New')
						|| this.state.form.IdentificationDocuments.some(d=>d.UserDecision === 'Removed'))
							&&
							<Button type="submit" variant='contained' color='primary' startIcon={<Add />} onClick={(e) => { e.preventDefault(); this.startIDVerification(true); }} title='Add ID Document'>Add ID Document</Button>
						}
						<Box component='span' display={this.retrieveFieldErrorFromFieldCode('IdentificationDocuments') ? 'block' : 'none'} style={{ marginTop: 10 }}>
							<Typography variant='body2' color='error'>
								{this.retrieveFieldErrorFromFieldCode('IdentificationDocuments')}
							</Typography>
						</Box>
					</Typography>
				</fieldset>
			);
		}
		else {
			let user = authHelpers.getAuthUser();

			const selfServiceIdentificationDocumentsEnabled = user.configurationSettings
				? user.configurationSettings.SelfServiceIdentificationDocumentsEnabled
				: settings.configurationSettings.SelfServiceIdentificationDocumentsEnabled;

			if (!selfServiceIdentificationDocumentsEnabled) {
				return null;
			}

			return (
				<>
					{this.state.form.IdentificationDocuments && this.state.form.IdentificationDocuments.map((item, index) => (
						<div key={item.FieldCode} id={item.FieldCode}>
							<IdentificationDocument
								setFieldState={(newIdentificationDocument) =>
									this.setIdentificationDocumentsFormState(`IdentificationDocuments`, newIdentificationDocument, index)
								}
								countriesList={this.props.countries}
								identificationDocument={item}
								addingMode={false}
								showSnackBar={this.showSnackBar}
								setFieldError={(error) => {
									this.props.clearFieldError(item.FieldCode, this.mapFieldCodeToErrorSection(item.FieldCode));

									if (this.props.fieldErrors[item.FieldCode]) {
										this.props.setFieldErrors({ ...this.props.fieldErrors, [item.FieldCode]: error });
									}
								}}
								fieldError={this.retrieveFieldErrorFromFieldCode(`IdentificationDocument${item.DocumentID}`)}
							/>
						</div>
					))}
					<CreateIdentificationDocument
						showSnackBar={this.showSnackBar}
						newIdentificationDocuments={this.state.form.SelfServiceIdentificationDocuments}
						countriesList={this.props.countries}
						addNewIdentificationDocument={(newIdentificationDocument) =>
							this.addSelfServiceIdentificationDocumentsFormState(newIdentificationDocument)
						}
						setFieldState={(newIdentificationDocument, index) =>
							this.setIdentificationDocumentsFormState(
								`SelfServiceIdentificationDocuments`,
								newIdentificationDocument,
								index
							)
						}
						setFieldError={(error, index) => {
							if (index) {
								this.props.setFieldErrors({ ...this.props.fieldErrors, [this.state.form[`SelfServiceIdentificationDocuments`][index].FieldCode]: error })
							}
						}}
						removeIdentificationDocument={(newValue) => this.removeIdentificationDocument(newValue)}
						fieldErrors={this.props.fieldErrors[`SelfServiceIdentificationDocuments`]}
					/>
				</>
			);
		}
	}

	buildDocumentationForm() {
		return this.getEntityDocumentTypes().map((item) => (
			<div key={item.FieldCode} id={item.FieldCode}>
				<DynamicFileControl
					field={item}
					eventHandle={this.handleFileChange}
					setFieldError={(error) => {
						this.props.clearFieldError(item.FieldCode, this.mapFieldCodeToErrorSection(item.FieldCode));

						if (this.props.fieldErrors[item.FieldCode]) {
							this.props.setFieldErrors({ ...this.props.fieldErrors, [item.FieldCode]: error })
						}
					}}
					fieldError={this.retrieveFieldErrorFromFieldCode(item.FieldCode)} />
			</div>
		));
	}

	addCommentsField() {
		return (
			<div id='SsuComments'>
				<fieldset className='entity-fieldset'>
					<Typography component='legend' color='primary'>
						<legend>Your Comments</legend>
					</Typography>
					<p>Specify additional information deemed relevant.</p>
					<TextField
						name='SelfServiceUserComment'
						value={this.state.form.SelfServiceUserComment}
						onChange={this.handleChange}
						fullWidth
						variant='filled'
						margin='none'
						multiline
						rows={6}
						rowsMax={10}
						inputProps={{ minLength: 10 }}
					/>
				</fieldset>
			</div>
		);
	}

	getComments() {
		return this.getEntityComments()
			? this.getEntityComments().map((comment) => {
				var commentDate = new Date(comment.CommentDate);
				return {
					...comment,
					CommentDate: `${commentDate.toLocaleDateString()} ${commentDate.toLocaleTimeString()}`,
					CentralUserName: comment.CentralUserName ? comment.CentralUserName : 'User',
				};
			})
			: [];
	}

	hasComments() {
		return this.getEntityComments() && this.getEntityComments().length > 0;
	}
	lastCommentIsSelfService() {
		return (
			this.getEntityComments() &&
			this.getEntityComments().length > 0 &&
			this.getEntityComments()[this.getEntityComments().length - 1].IsSelfServiceUser
		);
	}

	getFieldNameByCode(fieldCode) {
		if (this.getEntityFields() && this.getEntityFields().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityFields().find((field) => field.FieldCode === fieldCode)

			return `Basic Details - ${field.FieldName}`;
		}
		else if (this.getEntityAddress() && this.getEntityAddress().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityAddress().find((field) => field.FieldCode === fieldCode);

			return `Basic Details - ${field.FieldName}`;
		}
		else if (this.getEntityCustomFields() && this.getEntityCustomFields().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityCustomFields().find((field) => field.FieldCode === fieldCode);

			return `Additional Information - ${field.FieldName}`;
		}
		else if (this.getEntityIdentificationDocuments() && this.getEntityIdentificationDocuments().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityIdentificationDocuments().find((field) => field.FieldCode === fieldCode);

			return `Identification Documents - ${field.DocumentTypeName}: ${field.DocumentID}`;
		}
		else if (this.getEntityRelatedCountryTypes() && this.getEntityRelatedCountryTypes().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityRelatedCountryTypes().find((field) => field.FieldCode === fieldCode);

			return `Associated Countries - ${field.FieldName}`;
		}
		else if (this.getEntityDocumentTypes() && this.getEntityDocumentTypes().find((field) => field.FieldCode === fieldCode)) {
			var field = this.getEntityDocumentTypes().find((field) => field.FieldCode === fieldCode);

			return `Documents - ${field.FieldName}`;
		}

	}

	addSubmitDialog() {
		return (
			<Dialog open={this.props.isSubmitDialogOpen} onClose={this.handleSubmitDialogClose}>
				<DialogTitle>Confirmation</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Please note that the following fields are required or have not been filled in correctly. If you would still
						like to submit the form without correcting these fields, please explain why in the comments field below:
					</DialogContentText>
					<div style={{ margin: 15 }}>
						{Object.entries(this.props.fieldErrors).map(([key, value]) => (
							<div key={key}>
								{value ? (
									<Typography variant='body2' color='secondary'>
										{this.getFieldNameByCode(key)} - {value}
									</Typography>
								) : (
									''
								)}
							</div>
						))}
					</div>

					{this.addCommentsField()}
					<Box component='span' display={this.state.submitDialogError ? 'block' : 'none'}>
						<Typography variant='body2' color='error'>
							{this.state.submitDialogError}
						</Typography>
					</Box>
				</DialogContent>
				<DialogActions style={{ margin: 10 }}>
					<Button onClick={this.handleSubmitDialogClose} color='secondary' variant='outlined'>
						Cancel
					</Button>
					<Button onClick={this.handleFormSubmitWithConfirmation} color='primary' variant='contained'>
						Submit
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	render() {
		let user = authHelpers.getAuthUser();

		const selfServiceIdentificationDocumentsEnabled = user.configurationSettings
			? user.configurationSettings.SelfServiceIdentificationDocumentsEnabled
			: settings.configurationSettings.SelfServiceIdentificationDocumentsEnabled;

		return (
			<>
				{this.hasComments() && !this.lastCommentIsSelfService() && (
					<MuiAlert style={{ margin: `20px` }} elevation={6} variant='filled' severity='info'>
						<a style={{ textDecoration: `none`, color: `white` }} href='#HistoryComments'>
							You have new comments on this change request.
						</a>

					</MuiAlert>
				)}
				{Object.keys(this.state.form).length ? (
					<>
						<form id='entityForm' onSubmit={this.handleFormSubmit} noValidate>
							<BasicCollapsible areaName='Basic Details'
								sectionName='EntityFields'
								show={this.getEntityFields() && this.getEntityFields().length > 0}
								expanded={this.props.expandedSections['EntityFields']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityFields'], 'EntityFields')}
							>
								{this.buildBasicFieldsFormSection()}
							</BasicCollapsible>

							<BasicCollapsible areaName='Address'
								sectionName='EntityAddress'
								show="true"
								expanded={this.props.expandedSections['EntityAddress']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityAddress'], 'EntityAddress')}
							>
								{this.buildAddressFieldsFormSection()}
							</BasicCollapsible>

							<BasicCollapsible areaName='Additional Information'
								sectionName='EntityCustomFields'
								show={this.getEntityCustomFields() && this.getEntityCustomFields().length > 0}
								expanded={this.props.expandedSections['EntityCustomFields']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityCustomFields'], 'EntityCustomFields')}
							>
								{this.buildCustomFieldsFormSection()}
							</BasicCollapsible>

							<BasicCollapsible areaName='Associated Countries'
								sectionName='EntityRelatedCountries'
								show={this.getEntityRelatedCountryTypes() && this.getEntityRelatedCountryTypes().length > 0}
								expanded={this.props.expandedSections['EntityRelatedCountries']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityRelatedCountries'], 'EntityRelatedCountries')}
							>
								{this.buildRelatedCoutriesFormSection()}
							</BasicCollapsible>

							<BasicCollapsible areaName='Documentation'
								sectionName='EntityDocumentTypes'
								show={this.getEntityDocumentTypes() && this.getEntityDocumentTypes().length > 0}
								expanded={this.props.expandedSections['EntityDocumentTypes']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityDocumentTypes'], 'EntityDocumentTypes')}
							>
								{this.buildDocumentationForm()}
							</BasicCollapsible>

							<BasicCollapsible areaName='Identification Documents'
								sectionName='EntityIdentificationDocuments'
								show={this.getEntity().EntityTypeCode === EntityTypeCodes.Individual && selfServiceIdentificationDocumentsEnabled}
								expanded={this.props.expandedSections['EntityIdentificationDocuments']}
								handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['EntityIdentificationDocuments'], 'EntityIdentificationDocuments')}
							>
								{this.buildIdentificationDocumentsForm()}
							</BasicCollapsible>

							{this.addCommentsField()}

							{/* MATTHIAS - TODO -  CREATE COMPONENT FOR THE HTML BELLOW*/}
							{this.getEntityComments() && this.getEntityComments().length > 0 && (
								<div id='HistoryComments'>
									<BasicCollapsible areaName='Comments History'
										show="true"
										expanded={this.props.expandedSections['CommentsHistory']}
										handleExpandClick={this.handleExpandClick.bind(this, !this.props.expandedSections['CommentsHistory'], 'CommentsHistory')}>
										<div style={{ padding: `20px 30px` }}>
											{this.getComments().map((comment, index) =>
												comment.IsSelfServiceUser && comment.Comment ? (
													<div
														id={`comment-${index}`}
														key={`comment-${index}`}
														style={{ display: `flex`, justifyContent: `flex-end` }}
													>
														<div
															style={{
																borderRadius: `20px`,
																padding: `10px`,
																background: `#e9eaf6`,
																display: `flex`,
																alignItems: `flex-end`,
																flexDirection: `column`,
															}}
														>
															<div
																style={{
																	alignSelf: `flex-start`,
																	alignItems: `center`,
																	display: `flex`,
																	width: `fit-content`,
																}}
															>
																<p style={{ margin: `0`, padding: `0  10px 0 0` }}>{comment.CentralUserName}</p>
																<p style={{ fontSize: `10px`, margin: `0`, padding: `0` }}>{comment.CommentDate}</p>
															</div>
															<p>{comment.Comment}</p>
														</div>
													</div>
												) : (
													<div
														id={`comment-${index}`}
														key={`comment-${index}`}
														style={{ display: `flex`, justifyContent: `flex-start` }}
													>
														<div
															style={{
																borderRadius: `20px`,
																padding: `10px`,
																background: `#f5f5f5`,
																display: `flex`,
																alignItems: `flex-end`,
																flexDirection: `column`,
															}}
														>
															<div
																style={{
																	alignSelf: `flex-start`,
																	alignItems: `center`,
																	display: `flex`,
																	justifyContent: `flex-start`,
																	width: `fit-content`,
																}}
															>
																<p style={{ margin: `0`, padding: `0  10px 0 0` }}>{comment.CentralUserName}</p>
																<p style={{ fontSize: `10px`, margin: `0`, padding: `0` }}>{comment.CommentDate}</p>
															</div>
															<p>{comment.Comment}</p>
														</div>
													</div>
												)
											)}
										</div>
									</BasicCollapsible>
								</div>
							)}
							{/* MATTHIAS - TODO - END NEW COMPONENT*/}

							<div className='form-actions'>
								<Button
									variant='contained'
									color='primary'
									size='large'
									disabled={this.props.isWaitingRequest}
									type='submit'
									style={{ marginRight: 15 }}
									startIcon={this.state.formInvalid ? <ErrorIcon color='error' /> : <ArrowUpwardIcon />}
								>
									Submit
								</Button>
								{this.addSubmitDialog()}
								<Button
									variant='contained'
									color='secondary'
									size='large'
									disabled={this.props.isWaitingRequest}
									startIcon={<SaveIcon />}
									onClick={this.handleFormSave}
								>
									Save
								</Button>
							</div>
						</form>
						<Box component='span' display={this.state.formInvalid ? 'block' : 'none'} style={{ marginTop: 10 }}>
							<Typography variant='body2' color='error'>
								*Please amend the form correctly before re-submitting, some data appears to be invalid.
							</Typography>
						</Box>
					</>
				) : (
					<div></div>
				)}
			</>
		);
	}
}

function mapStateToProps(state) {
	return {
		expandedSections: state.selfService.expandedSections,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			selfService: bindActionCreators(selfServiceActions, dispatch)
		}
	};
}

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(memo(EntityFields)));
